const evidenciaPrefixPath = '/external/evidencna-aplikacia';
const pripomienkyPrefixPath = '/internal/sprava-pripomienok';

export {
  evidenciaPrefixPath,
  pripomienkyPrefixPath,
};
